import React from 'react'
import logo from '../static/imgs/logo.png'

export default function (propriedades) {
  return (
    <div>
      <header className='cabecalho'>
        <img src={logo} alt={`Logo`} />
      </header>
    </div>
  )
}
